const state = () => ({
    xcrossSeller:[],
    garantie:[],
    upgrades:[]
});

const mutations =
    {
        setXCrossSeller(state, request)
        {
            state.xcrossSeller = request;
        },
        setGarantie(state, request)
        {
            state.garantie = request;
        },
        setUpgrades(state, request)
        {
            state.upgrades.push(request);
        }
    };

export default
{
    state,
    mutations
};
